import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelList1: [],
    modelList2: [],
    numCog: null,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    modelList1: (state) => state.modelList1,
    modelList2: (state) => state.modelList2,
    numCog: (state) => state.cognitiveAspectId,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.modelList1 = Array.isArray(recordsData?.modelList1)
        ? recordsData.modelList1
        : [];

      state.modelList2 = Array.isArray(recordsData?.modelList2)
        ? recordsData.modelList2
        : [];

      state.cognitiveAspectId = recordsData?.cognitiveAspectId ?? null;
    },
    SET_MODEL_LIST1(state, payload) {
      state.modelList1 = Array.isArray(payload) ? payload : [];
    },
    SET_MODEL_LIST2(state, payload) {
      state.modelList2 = Array.isArray(payload) ? payload : [];
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const res = await apiClient.caxACGxThoughtPt2Schema();
        const schema = res.data;
        commit('SET_SCHEMA', schema);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelCAxACGxThoughtPt2(clinicalHistories_id, institutions_profes_id);
        const recordsData = res?.data?.data ?? {};
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createCAxACGxThoughtPt2(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const preparedModel = prepareModel(rootState, model);
        const id = preparedModel.cognitiveAspectId;
        await apiClient.updateCAxACGxThoughtPt2(id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    updateModelList1({ commit }, payload) {
      commit('SET_MODEL_LIST1', payload);
    },

    updateModelList2({ commit }, payload) {
      commit('SET_MODEL_LIST2', payload);
    },
  },
};
